<template>
  <div class="back-wrapper">
    <div class="back-left" @click="clickBtn">
      <span class="iconfont icon-xiangzuojiantou1"></span>
    </div>
    <div class="back-center">{{backParams.title}}</div>
    <div class="back-right"></div>
  </div>
</template>
<script>
// backParams 接受的参数

export default{
  name: 'headerBack',
  props: {
    backParams: {
      type: Object
    }
  },
  data () {
    return {
      isShowBack: true
    }
  },
  mounted () {
    this.isShowBack = this.isAndroid_ios()
  },
  methods: {
    // 判断是否是安卓还是ios
    isAndroid_ios () {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      return isAndroid === true
    },
    clickBtn() {
      this.$emit('backBtn')
    }
  }
}
</script>
<style lang="scss" scoped>
.back-wrapper{
  width: 100%;
  height: 50px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  border-bottom: 1px solid #f1f1f1;
  font-size: 16px;
  .back-left {
    width: 40px;
    height: inherit;
    text-align: center;
    line-height: 50px;
  }
  .back-center {
    flex: auto;
    text-align: center;
  }
  .back-right {
    width: 40px;
    text-align: center;
  }
}
</style>
